// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7":"bffa7eb6e6517c64","154":"13d85af55f09e6ee","436":"9aebdc760967e253","585":"5ee335b2b8acf92b"}[chunkId] + ".css";
};